if (!window.RoyalClosetOfferCampaign) {
  window.RoyalClosetOfferCampaign = {
    storageKey: 'rc-offer-campaign',
    activeOfferText: 'SIGN UP FOR EXCLUSIVE DISCOUNTS AND PRE-LAUNCH ACCESS',
    announcementSignupText: 'SIGN UP FOR EXCLUSIVE DISCOUNTS AND PRE-LAUNCH ACCESS',
    footerSignupText: 'Sign-up for exclusive discounts and pre-launch access.',
    retiredOfferTexts: [
      'First order? 20% off auto-applied at checkout 🤎',
      'First purchase? 20% off auto-applied at checkout 🤎',
      'Limited time: 30% off lead with harness purchase',
      'Limited time: 30% off matching leads',
    ],

    capture() {
      try {
        const params = new URLSearchParams(window.location.search);
        const offer = params.get('offer') || params.get('rc_offer');

        if (['matchme30', 'matchme50'].includes(offer?.toLowerCase())) {
          window.sessionStorage?.setItem(this.storageKey, 'matchme30');
        }
      } catch (_) {
        // Ignore storage access issues.
      }
    },

    getOffer() {
      try {
        return window.sessionStorage?.getItem(this.storageKey) || '';
      } catch (_) {
        return '';
      }
    },

    isMatchMe() {
      return true;
    },

    applyMessaging() {
      const useMatchMeCopy = this.isMatchMe();

      if (useMatchMeCopy) {
        document.documentElement.dataset.rcOfferCampaign = 'matchme30';
      } else {
        delete document.documentElement.dataset.rcOfferCampaign;
      }

      document.querySelectorAll('[data-rc-offer-copy]').forEach((element) => {
        const shouldShow = useMatchMeCopy
          ? element.dataset.rcOfferCopy === 'matchme30'
          : element.dataset.rcOfferCopy !== 'matchme30';
        element.hidden = !shouldShow;
      });

      document.querySelectorAll('[data-rc-offer-text]').forEach((element) => {
        const nextText = useMatchMeCopy
            ? (element.dataset.rcOfferMatchme30Text || element.dataset.rcOfferMatchme50Text)
            : element.dataset.rcOfferNc15Text;
        if (nextText) element.textContent = nextText;

        const nextHref = useMatchMeCopy
            ? (element.dataset.rcOfferMatchme30Href || element.dataset.rcOfferMatchme50Href)
            : element.dataset.rcOfferNc15Href;
        if (nextHref && element.matches('a')) element.setAttribute('href', nextHref);
      });

      this.replaceRetiredOfferText();
    },

    replaceRetiredOfferText(root = document) {
      const targets = [
        '.announcement-bar__link',
        '.wo-badge--offer',
        '.wo-badge--offer span',
        '.rc-sc20-countdown span',
        '.rc-footer__newsletter-copy p',
        '[data-rc-offer-copy]',
        '[data-rc-offer-text]',
      ];

      root.querySelectorAll(targets.join(',')).forEach((element) => {
        const text = element.textContent.trim();
        const nextText = this.replacementTextForElement(element);
        if (this.retiredOfferTexts.includes(text)) {
          element.textContent = nextText;
        }
        if (this.retiredOfferTexts.includes(element.getAttribute('aria-label') || '')) {
          element.setAttribute('aria-label', nextText);
        }
      });
    },

    replacementTextForElement(element) {
      if (element.matches('.announcement-bar__link, [data-rc-offer-text]')) {
        const isAnnouncement = element.closest('.announcement-bar');
        if (isAnnouncement) return this.announcementSignupText;
      }
      if (element.matches('.rc-footer__newsletter-copy p')) return this.footerSignupText;
      return this.activeOfferText;
    },

    init() {
      this.capture();
      this.applyMessaging();

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.applyMessaging();
          this.observeOfferText();
        }, { once: true });
      } else {
        this.observeOfferText();
      }

      document.addEventListener('shopify:section:load', (event) => this.replaceRetiredOfferText(event.target));
    },

    observeOfferText() {
      if (this.offerObserver || !document.body) return;

      this.offerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              this.replaceRetiredOfferText(node);
            }
          });
        });
      });
      this.offerObserver.observe(document.body, { childList: true, subtree: true });
    },
  };

  window.RoyalClosetOfferCampaign.init();
}

if (!customElements.get('cart-discount-code')) {
  customElements.define(
    'cart-discount-code',
    class CartDiscountCode extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.form = this.querySelector('[data-rc-discount-form]');
        this.input = this.querySelector('[data-rc-discount-input]');
        this.button = this.querySelector('[data-rc-discount-submit]');
        this.status = this.querySelector('[data-rc-discount-status]');

        this.form?.addEventListener('submit', this.onSubmit.bind(this));
        this.addEventListener('click', this.onRemoveClick.bind(this));
        this.captureCampaignOffer();
        this.applyCampaignMessaging();
        this.restoreStatus();
        this.clearLegacyDismissals();
        this.syncAutomaticDiscounts();
      }

      async onSubmit(event) {
        event.preventDefault();

        const code = this.input?.value.trim();
        if (!code || !this.form || !this.button) {
          this.input?.reportValidity();
          return;
        }

        this.releaseMobileFocus();
        this.input?.blur();
        this.resetMobileViewportZoom();
        this.setLoading(true);
        this.setStatus('');

        try {
          const currentCart = await this.fetchCart();
          this.clearAutoApplyDismissed(code);
          const codeAlreadyApplied = this.isCodeApplied(currentCart, code);
          const existingCodes = (currentCart.discount_codes || [])
            .filter((discount) => discount.applicable !== false)
            .map((discount) => discount.code)
            .filter(Boolean);

          const isDifferentCode = !existingCodes.some(
            (existingCode) => existingCode.toLowerCase() === code.toLowerCase()
          );
          const nextCodes = isDifferentCode ? [...existingCodes, code] : existingCodes;
          if (!this.isAllowedDiscountCombination(nextCodes)) {
            this.releaseMobileFocus();
            this.resetMobileViewportZoom();
            this.setLoading(false);
            this.setStatus('This code cannot be combined with the codes already in your cart.', true);
            return;
          }

          if (isDifferentCode) {
            existingCodes.push(code);
          }

          const sections = this.getSectionsToRender();
          const response = await fetch(`${routes.cart_update_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              discount: existingCodes.join(','),
              sections: sections.map((section) => section.section),
              sections_url: window.location.pathname,
            }),
          });
          const cart = await response.json();

          if (!response.ok) {
            throw new Error(cart.description || cart.message || 'The discount code could not be applied.');
          }

          const applied = codeAlreadyApplied || this.isCodeApplied(cart, code);
          const resultMessage = applied
            ? 'Discount code applied.'
            : 'That discount code is not valid for this cart.';

          this.storeStatus(resultMessage, !applied);
          this.renderSections(cart.sections, sections);
          this.resetMobileViewportZoom();

          requestAnimationFrame(() => {
            const replacement = document.querySelector(
              `cart-discount-code[data-rc-discount-context="${this.dataset.rcDiscountContext}"]`
            );
            if (!replacement) return;

            replacement.setStatus(resultMessage, !applied);
            window.setTimeout(() => replacement.clearStoredStatus(), 5000);

            if (!applied && replacement.input) {
              replacement.input.value = code;
            }

            replacement.releaseMobileFocus();
            replacement.resetMobileViewportZoom();
          });
        } catch (error) {
          this.releaseMobileFocus();
          this.resetMobileViewportZoom();
          this.setStatus(error.message || 'The discount code could not be applied. Please try again.', true);
          this.setLoading(false);
        }
      }

      async onRemoveClick(event) {
        const removeButton = event.target.closest('[data-rc-discount-remove]');
        if (!removeButton || removeButton.disabled) return;

        const code = removeButton.dataset.rcDiscountRemove?.trim();
        if (!code) return;

        this.setLoading(true);
        this.setRemoveButtonsLoading(true);
        this.setStatus('');

        try {
          const currentCart = await this.fetchCart();
          if (this.isAutoManagedCode(code)) {
            this.setAutoApplyDismissed(code);
            this.setAutoApplyAttempted(code);
          }
          const remainingCodes = (currentCart.discount_codes || [])
            .map((discount) => discount.code)
            .filter(Boolean)
            .filter((existingCode) => existingCode.toLowerCase() !== code.toLowerCase());

          const sections = this.getSectionsToRender();
          const response = await fetch(`${routes.cart_update_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              discount: remainingCodes.join(','),
              sections: sections.map((section) => section.section),
              sections_url: window.location.pathname,
            }),
          });
          const cart = await response.json();

          if (!response.ok) {
            throw new Error(cart.description || cart.message || 'The discount code could not be removed.');
          }

          const stillApplied = this.isCodeApplied(cart, code);
          const resultMessage = stillApplied
            ? 'That discount code could not be removed.'
            : 'Discount code removed.';

          this.storeStatus(resultMessage, stillApplied);
          this.renderSections(cart.sections, sections);

          requestAnimationFrame(() => {
            const replacement = document.querySelector(
              `cart-discount-code[data-rc-discount-context="${this.dataset.rcDiscountContext}"]`
            );
            if (!replacement) return;

            replacement.setStatus(resultMessage, stillApplied);
            window.setTimeout(() => replacement.clearStoredStatus(), 5000);
          });
        } catch (error) {
          this.setStatus(error.message || 'The discount code could not be removed. Please try again.', true);
          this.setLoading(false);
          this.setRemoveButtonsLoading(false);
        }
      }

      async autoApplyDiscount() {
        const code = this.dataset.rcAutoDiscountCode?.trim();
        if (!code || this.getAutoApplyAttempted(code) || this.getAutoApplyDismissed(code)) return;

        try {
          const currentCart = await this.fetchCart();
          if (!currentCart.items?.length || this.isCodeApplied(currentCart, code)) return;

          const existingCodes = (currentCart.discount_codes || [])
            .filter((discount) => discount.applicable !== false)
            .map((discount) => discount.code)
            .filter(Boolean);
          const codesToApply = [...existingCodes, code];

          if (!this.isAllowedDiscountCombination(codesToApply)) return;

          this.setAutoApplyAttempted(code);

          const sections = this.getSectionsToRender();
          const response = await fetch(`${routes.cart_update_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              discount: codesToApply.join(','),
              sections: sections.map((section) => section.section),
              sections_url: window.location.pathname,
            }),
          });
          const cart = await response.json();

          if (!response.ok || !this.isCodeApplied(cart, code)) return;
          this.renderSections(cart.sections, sections);
        } catch (_) {
          this.setAutoApplyAttempted(code);
        }
      }

      async syncAutomaticDiscounts() {
        const configuredAutoCode = this.dataset.rcAutoDiscountCode?.trim();
        const matchMeCode = 'MATCHME30';
        const legacyMatchMeCode = 'MATCHME50';
        const newCustomerCode =
          this.normalizeCode(configuredAutoCode) === this.normalizeCode(matchMeCode)
            ? ''
            : configuredAutoCode;

        try {
          const currentCart = await this.fetchCart();
          if (!currentCart.items?.length) return;

          let nextCodes = (currentCart.discount_codes || [])
            .filter((discount) => discount.applicable !== false)
            .map((discount) => discount.code)
            .filter(Boolean);
          let changed = false;

          if (
            newCustomerCode &&
            !this.getAutoApplyAttempted(newCustomerCode) &&
            !this.getAutoApplyDismissed(newCustomerCode) &&
            !this.hasDiscountCode(currentCart, newCustomerCode, nextCodes)
          ) {
            const candidateCodes = this.dedupeCodes([...nextCodes, newCustomerCode]);

            if (this.isAllowedDiscountCombination(candidateCodes)) {
              nextCodes = candidateCodes;
              changed = true;
              this.setAutoApplyAttempted(newCustomerCode);
            }
          }

          const oldMatchMeCodes = [matchMeCode, legacyMatchMeCode];
          const hasOldMatchMeCode = oldMatchMeCodes.some((code) =>
            this.hasDiscountCode(currentCart, code, nextCodes)
          );

          if (hasOldMatchMeCode) {
            nextCodes = nextCodes.filter(
              (code) =>
                !oldMatchMeCodes.some(
                  (oldCode) => this.normalizeCode(code) === this.normalizeCode(oldCode)
                )
            );
            changed = true;
          }

          if (!changed) return;

          const sections = this.getSectionsToRender();
          const response = await fetch(`${routes.cart_update_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              discount: nextCodes.join(','),
              sections: sections.map((section) => section.section),
              sections_url: window.location.pathname,
            }),
          });
          const cart = await response.json();

          if (!response.ok) return;
          this.renderSections(cart.sections, sections);
          requestAnimationFrame(() => this.applyCampaignMessaging());
        } catch (_) {
          if (newCustomerCode) this.setAutoApplyAttempted(newCustomerCode);
        }
      }

      captureCampaignOffer() {
        window.RoyalClosetOfferCampaign?.capture();
      }

      getCampaignOffer() {
        return window.RoyalClosetOfferCampaign?.getOffer() || '';
      }

      isMatchMeCampaign() {
        return window.RoyalClosetOfferCampaign?.isMatchMe() || false;
      }

      applyCampaignMessaging() {
        window.RoyalClosetOfferCampaign?.applyMessaging();
      }

      normalizeCode(code) {
        return code?.trim().toLowerCase();
      }

      dedupeCodes(codes) {
        return codes.filter((code, index) => {
          const normalizedCode = this.normalizeCode(code);
          return normalizedCode && codes.findIndex((candidate) => this.normalizeCode(candidate) === normalizedCode) === index;
        });
      }

      getNc20StackableCodes() {
        return [
          'tuckerandsally10',
          'bowwow10',
          'truffle10',
          'sirteddy10',
          'missellie10',
        ];
      }

      isAllowedDiscountCombination(codes) {
        const uniqueCodes = [...new Set(codes.map((code) => this.normalizeCode(code)).filter(Boolean))];
        if (uniqueCodes.some((code) => ['matchme30', 'matchme50'].includes(code))) return false;
        if (uniqueCodes.length <= 1) return true;

        const newCustomerCode = 'nc15';
        const stackableCodes = this.getNc20StackableCodes();
        const allowedCodes = [newCustomerCode, ...stackableCodes];
        const stackableCodeCount = uniqueCodes.filter((code) => stackableCodes.includes(code)).length;

        if (uniqueCodes.length > 3) return false;
        if (uniqueCodes.some((code) => !allowedCodes.includes(code))) return false;
        if (stackableCodeCount > 1) return false;
        if (stackableCodeCount && !uniqueCodes.includes(newCustomerCode)) return false;

        return true;
      }

      hasDiscountCode(cart, code, codes = []) {
        const normalizedCode = this.normalizeCode(code);
        return (
          codes.some((existingCode) => this.normalizeCode(existingCode) === normalizedCode) ||
          (cart.discount_codes || []).some(
            (discount) => this.normalizeCode(discount.code) === normalizedCode
          ) ||
          this.isCodeApplied(cart, code)
        );
      }

      hasActiveDiscountCode(cart, code, codes = []) {
        const normalizedCode = this.normalizeCode(code);
        return (
          codes.some((existingCode) => this.normalizeCode(existingCode) === normalizedCode) ||
          this.isCodeApplied(cart, code)
        );
      }

      hasMatchingHarnessLeadPair(cart) {
        const harnesses = new Map();
        const leads = new Map();

        (cart.items || []).forEach((item) => {
          if (this.isWalkKitItem(item)) return;

          const descriptor = this.getCartItemDescriptor(item);
          const quantity = Number(item.quantity || 0);

          if (quantity <= 0) return;

          if (descriptor.includes('harness')) {
            const styleKey = this.getMatchMeStyleKey(item, 'harness');
            if (styleKey) harnesses.set(styleKey, (harnesses.get(styleKey) || 0) + quantity);
          }

          if (descriptor.includes('lead')) {
            const styleKey = this.getMatchMeStyleKey(item, 'lead');
            if (styleKey) leads.set(styleKey, (leads.get(styleKey) || 0) + quantity);
          }
        });

        return [...harnesses.entries()].some(([styleKey, harnessQuantity]) => {
          const leadQuantity = leads.get(styleKey) || 0;
          return Math.min(harnessQuantity, leadQuantity) > 0;
        });
      }

      isWalkKitItem(item) {
        const descriptor = this.getCartItemDescriptor(item);
        return descriptor.includes('walk kit') || descriptor.includes('walk-kit');
      }

      getCartItemDescriptor(item) {
        return [
          item.handle,
          item.product_handle,
          item.product_type,
          item.product_title,
          item.title,
          item.url,
        ]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
      }

      getMatchMeStyleKey(item, itemType) {
        const source =
          item.handle ||
          item.product_handle ||
          item.product_title ||
          item.title ||
          item.url?.split('/products/')[1] ||
          '';

        return source
          .toString()
          .toLowerCase()
          .split('?')[0]
          .replace(/^\/?products\//, '')
          .replace(new RegExp(`[-\\s]+${itemType}$`), '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      isCodeApplied(cart, code) {
        const normalizedCode = code.toLowerCase();
        const appliedDiscount = (cart.discount_codes || []).find(
          (discount) => discount.code?.toLowerCase() === normalizedCode
        );
        const appliedAtCartLevel = (cart.cart_level_discount_applications || []).some(
          (discount) =>
            discount.discount_application?.title?.toLowerCase() === normalizedCode
        );
        const appliedToLineItem = (cart.items || []).some((item) =>
          (item.discounts || []).some(
            (discount) => discount.title?.toLowerCase() === normalizedCode
          )
        );

        return appliedDiscount?.applicable === true || appliedAtCartLevel || appliedToLineItem;
      }

      getStatusStorageKey() {
        return `rc-cart-discount-status-${this.dataset.rcDiscountContext || 'cart'}`;
      }

      getAutoApplyStorageKey(code) {
        return `rc-cart-auto-discount-${code.toLowerCase()}-${this.dataset.rcDiscountContext || 'cart'}`;
      }

      getAutoDismissedStorageKey(code) {
        return `rc-cart-auto-discount-dismissed-${code.toLowerCase()}-${this.dataset.rcDiscountContext || 'cart'}`;
      }

      getAutoApplyAttempted(code) {
        try {
          return sessionStorage.getItem(this.getAutoApplyStorageKey(code)) === 'true';
        } catch (_) {
          return false;
        }
      }

      setAutoApplyAttempted(code) {
        try {
          sessionStorage.setItem(this.getAutoApplyStorageKey(code), 'true');
        } catch (_) {
          // Auto-apply can still safely fail without browser storage.
        }
      }

      getAutoApplyDismissed(code) {
        try {
          // Dismissal is per-visit only: removing the auto code once must not
          // block the offer for every future visit on this device.
          return sessionStorage.getItem(this.getAutoDismissedStorageKey(code)) === 'true';
        } catch (_) {
          return false;
        }
      }

      setAutoApplyDismissed(code) {
        try {
          sessionStorage.setItem(this.getAutoDismissedStorageKey(code), 'true');
        } catch (_) {
          // Manual removal should still proceed if browser storage is unavailable.
        }
      }

      clearAutoApplyDismissed(code) {
        try {
          sessionStorage.removeItem(this.getAutoDismissedStorageKey(code));
          localStorage.removeItem(this.getAutoDismissedStorageKey(code));
        } catch (_) {
          // No action needed when browser storage is unavailable.
        }
      }

      clearLegacyDismissals() {
        // Dismissals used to be stored in localStorage, permanently killing
        // auto-apply on that device. Drop any leftover flags.
        try {
          const codes = ['matchme30', 'matchme50', (this.dataset.rcAutoDiscountCode || '').toLowerCase()];
          codes.filter(Boolean).forEach((code) => {
            localStorage.removeItem(this.getAutoDismissedStorageKey(code));
          });
        } catch (_) {
          // No action needed when browser storage is unavailable.
        }
      }

      isAutoManagedCode(code) {
        const normalizedCode = this.normalizeCode(code);
        return normalizedCode && normalizedCode === this.normalizeCode(this.dataset.rcAutoDiscountCode);
      }

      storeStatus(message, isError) {
        try {
          sessionStorage.setItem(this.getStatusStorageKey(), JSON.stringify({ message, isError }));
        } catch (_) {
          // The live status still works when browser storage is unavailable.
        }
      }

      restoreStatus() {
        try {
          const storedStatus = sessionStorage.getItem(this.getStatusStorageKey());
          if (!storedStatus) return;

          const { message, isError } = JSON.parse(storedStatus);
          this.setStatus(message, isError);
        } catch (_) {
          this.clearStoredStatus();
        }
      }

      clearStoredStatus() {
        try {
          sessionStorage.removeItem(this.getStatusStorageKey());
        } catch (_) {
          // No action needed when browser storage is unavailable.
        }
      }

      fetchCart() {
        return fetch(`${routes.cart_url}.js`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        }).then((response) => {
          if (!response.ok) throw new Error('The cart could not be refreshed.');
          return response.json();
        });
      }

      getSectionsToRender() {
        if (this.dataset.rcDiscountContext === 'drawer') {
          return [
            { id: 'cart-drawer', section: 'cart-drawer', selector: '#CartDrawer' },
            { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
          ];
        }

        const cartItems = document.getElementById('main-cart-items');
        const cartFooter = document.getElementById('main-cart-footer');

        return [
          {
            id: 'main-cart-items',
            section: cartItems?.dataset.id,
            selector: '.js-contents',
          },
          {
            id: 'main-cart-footer',
            section: cartFooter?.dataset.id,
            selector: '.js-contents',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'cart-live-region-text',
            section: 'cart-live-region-text',
            selector: '.shopify-section',
          },
        ].filter((section) => section.section);
      }

      renderSections(renderedSections, sections) {
        if (!renderedSections) return;

        if (this.dataset.rcDiscountContext === 'drawer') {
          const drawer = document.querySelector('cart-drawer');
          if (drawer?.renderSections) drawer.renderSections(renderedSections);
          return;
        }

        sections.forEach((section) => {
          const targetRoot = document.getElementById(section.id);
          const target = targetRoot?.querySelector(section.selector) || targetRoot;
          const html = renderedSections[section.section];
          if (!target || !html) return;

          const sourceDocument = new DOMParser().parseFromString(html, 'text/html');
          const source = sourceDocument.querySelector(section.selector);
          if (source) target.innerHTML = source.innerHTML;
        });
      }

      setLoading(isLoading) {
        if (!this.button || !this.input) return;

        this.button.disabled = isLoading;
        this.input.disabled = isLoading;
        this.button.textContent = isLoading ? 'Applying' : 'Apply';
        this.toggleAttribute('aria-busy', isLoading);
      }

      setRemoveButtonsLoading(isLoading) {
        this.querySelectorAll('[data-rc-discount-remove]').forEach((button) => {
          button.disabled = isLoading;
        });
      }

      setStatus(message, isError = false) {
        if (!this.status) return;

        this.status.textContent = message;
        this.status.classList.toggle('is-error', isError);
      }

      releaseMobileFocus() {
        const activeElement = document.activeElement;
        if (activeElement && typeof activeElement.blur === 'function') {
          activeElement.blur();
        }
      }

      resetMobileViewportZoom() {
        if (!window.matchMedia('(max-width: 749px)').matches) return;

        const viewport = document.querySelector('meta[name="viewport"]');
        if (!viewport) return;

        const originalContent = viewport.getAttribute('content') || 'width=device-width, initial-scale=1.0';
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0');

        window.setTimeout(() => {
          viewport.setAttribute('content', originalContent);
        }, 350);
      }
    }
  );
}
